// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"t7","controlPlay":"t8","controlElement":"t9","lowerControlWrapper":"t-","controlBottomOffset":"t_","lowerControlIconWrapper":"ua","lowerControlIcon":"ub","show":"uc"};